import React, { useEffect, useState } from 'react'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { useQuery } from '@apollo/client'
import { GET_RAZOR_ALL_TRANSATIONS } from '../../graphql/query'
import { useStateWithCallback } from '../../utils/hooks/useStateWithCallback'
import LoadingSpinner from '../../components/LoadingSpinner'

pdfMake.vfs = pdfFonts as unknown as typeof pdfMake.vfs

const RazorpayDetails = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [razorpayDate, setRazorpayDate] = useStateWithCallback<any>({
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0]
  })

  useEffect(() => {
    razorpayRefetch({
      input: {
        ...razorpayDate
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [razorpayDate])

  const {
    loading,
    error,
    data: RazorpayData,
    refetch: razorpayRefetch
  } = useQuery(GET_RAZOR_ALL_TRANSATIONS, {
    variables: {
      input: {
        ...razorpayDate
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Configuration'
      }
    }
  })

  const accountPerPage = 10
  const transactions = RazorpayData?.getRazorAllTransations?.data || []
  const totalCount = transactions?.length
  const totalPages = Math.ceil(totalCount / accountPerPage)

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name
    const value = e.target.value

    setRazorpayDate((prevValue: any) => ({
      ...prevValue,
      [name]: value
    }))
  }

  const generatePdf = (invoiceData: any) => {
    const docDefinition: any = {
      content: [
        { text: 'Razorpay Transaction Invoice', style: 'header' },
        { text: `Transaction ID: ${invoiceData.id}`, style: 'subheader' },
        { text: `Amount Paid: ₹${(invoiceData.amount / 100).toFixed(2)}` },
        { text: `Billing Date: ${new Date(invoiceData.created_at * 1000).toLocaleString()}` },
        { text: `Status: ${invoiceData.status.toUpperCase()}` },
        { text: `Payment Method: ${invoiceData.method.toUpperCase()}` },
        { text: `VPA (UPI): ${invoiceData.upi?.vpa || 'N/A'}` },
        { text: `Fee Charged: ₹${(invoiceData.fee / 100).toFixed(2)}` },
        { text: `Tax: ₹${(invoiceData.tax / 100).toFixed(2)}` },
        { text: '' },
        { text: 'Terms and Conditions', style: 'subheader' },
        { text: '1. All payments are final and non-refundable unless specified otherwise.' },
        { text: '2. Any disputes shall be resolved under the jurisdiction of Delhi, India.' },
        { text: '3. For support, contact info@botgotechpvtltd.com.' }
      ],
      styles: {
        header: { fontSize: 18, bold: true, margin: [0, 0, 0, 10] },
        subheader: { fontSize: 14, bold: true, margin: [0, 10, 0, 5] }
      }
    }
    pdfMake.createPdf(docDefinition).download(`Transaction_${invoiceData.id}.pdf`)
  }

  const renderTableRows = (data: any) => {
    return data?.map((row: any, index: any) => (
      <tr key={index}>
        <td>
          <span className='badge badge-light-danger fs-7 fw-bold btn-active-light-primary'>
            {row.id}
          </span>
        </td>
        <td>₹{(row.amount / 100).toFixed(2)}</td>
        <td>{new Date(row.created_at * 1000).toLocaleString()}</td>
        <td>
          <div
            className={
              row.status === 'captured'
                ? 'badge badge-light-success'
                : row.status === 'pending'
                ? 'badge badge-light-warning'
                : 'badge badge-light-danger'
            }
          >
            {row.status.toUpperCase()}
          </div>
        </td>
        <td>{row.method.toUpperCase()}</td>
        <td>{row.upi?.vpa || 'N/A'}</td>
        <td>₹{(row.fee / 100).toFixed(2)}</td>
        <td>₹{(row.tax / 100).toFixed(2)}</td>
        <td>
          <button
            className='btn btn-sm btn-primary my-1 d-flex align-items-center gap-1'
            onClick={() => generatePdf(row)}
          >
            <i className='bi bi-cloud-arrow-down fs-2'></i>
            Download
          </button>
        </td>
      </tr>
    ))
  }

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
  }

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }

  const generatePaginationNumbers = () => {
    let numbers = []
    for (let i = 1; i <= totalPages; i++) {
      numbers.push(i)
    }
    return numbers
  }
  const displayedTransactions = transactions.slice(
    (currentPage - 1) * accountPerPage,
    currentPage * accountPerPage
  )

  if (error) return <h1>{error.message}</h1>

  return (
    <>
      {!!loading ? (
        <div className='h-100 d-flex align-items-center justify-content-center '>
          <LoadingSpinner />
        </div>
      ) : (
        <div className='card mb-5 mb-xl-10'>
          <div className=''>
            <div className='card-header'>
              <div>
                <h3>Razorpay Payment History ({totalCount || 0})</h3>
                <div className='fs-6 fw-semibold text-gray-500'>
                  See history of your Razorpay payment
                </div>
              </div>
              <div className='col-4 d-flex justify-content-end mb-3'>
                <div className='d-flex'>
                  <div className='d-flex align-items-center'>
                    <label className='form-label me-2' htmlFor='startDate'>
                      From:
                    </label>
                    <input
                      type='date'
                      name='startDate'
                      id='startDate'
                      value={razorpayDate.startDate}
                      min={
                        new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
                      }
                      max={razorpayDate.endDate || ''}
                      className='form-control mx-3'
                      onChange={handleDateChange}
                    />
                  </div>
                </div>
                <div className='d-flex align-items-center'>
                  <label className='form-label me-2' htmlFor='endDate'>
                    To:
                  </label>
                  <input
                    type='date'
                    name='endDate'
                    id='endDate'
                    value={razorpayDate.endDate}
                    min={razorpayDate.startDate || ''}
                    max={new Date().toISOString().split('T')[0]}
                    className='form-control mx-3'
                    onChange={handleDateChange}
                  />
                </div>
              </div>
            </div>

            <div className='tab-content'>
              <div id='kt_billing_months' className='card-body p-0 tab-pane fade show active'>
                <div className='table-responsive'>
                  {displayedTransactions.length > 0 ? (
                    <table className='table table-row-bordered align-middle gy-4 gs-9'>
                      <thead className='border-bottom border-gray-200 fs-6 fw-bold bg-light bg-opacity-75'>
                        <tr>
                          <td className='min-w-100px'>Transaction ID</td>
                          <td className='min-w-100px'>Amount (₹)</td>
                          <td className='min-w-100px'>Billing Date</td>
                          <td className='min-w-100px'>Status</td>
                          <td className='min-w-100px'>Payment Method</td>
                          <td className='min-w-100px'>VPA (UPI)</td>
                          <td className='min-w-100px'>Fee (₹)</td>
                          <td className='min-w-100px'>Tax (₹)</td>
                          <td className='min-w-100px'>Download Invoice</td>
                        </tr>
                      </thead>
                      <tbody className='fw-semibold text-gray-600'>
                        {displayedTransactions.length > 0 ? (
                          renderTableRows(displayedTransactions)
                        ) : (
                          <tr>
                            <td className='text-center p-5 fw-bold text-gray-500'>
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  ) : (
                    <div className='text-center p-5 fw-bold text-gray-500'>No data available</div>
                  )}
                </div>
                <div className='row m-2'>
                  <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start dt-toolbar'></div>
                  <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                    <div className='dt-paging paging_simple_numbers'>
                      <div
                        className='dataTables_paginate paging_simple_numbers'
                        id='kt_table_users_paginate'
                      >
                        <ul className='pagination pb-2'>
                          <li
                            className={`paginate_button page-item ${
                              currentPage === 1 ? 'disabled' : ''
                            }`}
                          >
                            <button
                              type='button'
                              aria-controls='kt_table_users'
                              data-dt-idx='0'
                              className='btn primary page-link'
                              onClick={prevPage}
                            >
                              <i className='previous'></i>
                            </button>
                          </li>
                          {generatePaginationNumbers().map((pageNumber) => (
                            <li
                              key={pageNumber}
                              className={`paginate_button page-item ${
                                currentPage === pageNumber ? 'active' : ''
                              }`}
                            >
                              <button
                                type='button'
                                aria-controls='kt_table_users'
                                data-dt-idx={pageNumber}
                                className='btn primary page-link'
                                onClick={() => paginate(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            </li>
                          ))}
                          <li
                            className={`paginate_button page-item ${
                              currentPage === totalPages ? 'disabled' : ''
                            }`}
                          >
                            <button
                              type='button'
                              aria-controls='kt_table_users'
                              data-dt-idx='0'
                              className='btn primary page-link'
                              onClick={nextPage}
                            >
                              <i className='next'></i>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default RazorpayDetails
